import { findColumnControlSelectedDecoration } from '../utils/decoration';
export { buildTableDecorationSet } from './build-table-decoration-set';
export { buildColumnResizingDecorationSet } from './build-column-resizing-decoration-set';
export var hasColumnSelectedDecorations = function (decorationSet) { return !!findColumnControlSelectedDecoration(decorationSet).length; };
export var removeColumnControlsSelected = function (decorationSet) {
    return decorationSet.remove(findColumnControlSelectedDecoration(decorationSet));
};
//# sourceMappingURL=index.js.map